export default __webpack_public_path__ + "static/media/scale.8e7d4c3b.svg";